module.exports = __webpack_public_path__ + "static/media/hit_and_run.6516c1c1.png";